import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';
import { spacingClassName, type SpacingToken } from '../spacing/catalog.js';

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  direction?: 'row' | 'column';
  gap?: SpacingToken;
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
  children: ReactNode;
}

const alignClassNames: Record<NonNullable<StackProps['align']>, string> = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
};

export function Stack({
  direction = 'column',
  gap = 'fieldGap',
  align,
  children,
  className,
  ...props
}: StackProps) {
  return (
    <div
      data-spacing={gap}
      className={cn(
        'flex',
        direction === 'row' ? 'flex-row' : 'flex-col',
        spacingClassName(gap),
        align ? alignClassNames[align] : undefined,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
